import { IApplicationDefinitionSummary } from '../application-definition/application-definition-summary';

export class SurveyDefinitionSummary implements IApplicationDefinitionSummary {
  public id: string;
  public title: string;
  public publicTitle: string;
  public hasExpired: boolean;
  public isArchived: boolean;
  public workspaceId: string | null;

  constructor() {}

  public static parse(data: any): SurveyDefinitionSummary {
    if (!data) return null;

    let survey = new SurveyDefinitionSummary();
    Object.assign(survey, data);

    return survey;
  }

  public isSharedFromOrg(isInOrg: boolean): boolean {
    return !isInOrg && !this.workspaceId;
  }
}
